import { useLogoutMutation, useMeQuery } from '../../../generated/graphql';

import Button from 'react-bootstrap/Button';
import React from 'react';
import { createHttpLink } from '@apollo/client';
import routes from '../../../routes/routes';
import { setContext } from '@apollo/client/link/context';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LogoutButtonProps {}

export const LogoutButton: React.FC<LogoutButtonProps> = () => {
    const { t } = useTranslation();

    const [logout] = useLogoutMutation();
    const { refetch, client } = useMeQuery();
    const history = useHistory();

    const onLogout = async () => {
        logout();
        const httpLink = createHttpLink({
            uri: `${process.env.REACT_APP_SERVER}/graphql`,
        });
        const authLink = setContext((_, { headers }) => {
            return {
                headers: {
                    ...headers,
                    authorization: '',
                },
            };
        });
        localStorage.setItem('token', '');
        client.setLink(authLink.concat(httpLink));
        await refetch();
        client.resetStore();
        window.location.href = 'https://ifnmu.sharepoint.com/SitePages/Home.aspx';
    };

    return (
        <div>
            <Button
                onClick={onLogout}
                style={{
                    backgroundColor: '#ffffff',
                    borderColor: '#2196F3',
                    color: '#2196F3',
                }}
                className="fw-bold"
            >
                {t('header.logout')}
            </Button>
        </div>
    );
};
